module.exports = {"LIQUIDITY_ACCOUNTS":{"WARNING":{"NO_ACCOUNTS":"Spiacenti! Non ci sono account. Puoi aggiungere il primo!"},"TABLE_COLUMN":{"ID":"ID","NAME":"Nome","NUMBER":"Numero","BALANCE":"Saldo","CURRENCY":"Valuta","IBAN":"IBAN","REFILL_DATE":"Data ultima ricarica"},"EDIT":{"SELECT_TITLE":"Seleziona account di liquidità"},"MODAL":{"HEADER":"Cambia account di liquidità","BODY":{"DESCRIPTION":"Per modificare il pool di liquidità di queste transazioni selezionalo dall'elenco sottostante. Tieni presente che questa azione non può essere annullata."}}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/it/liquidity_accounts.json
// module id = 718
// module chunks = 0